export default {
  // 基础通用
  base_common: {
    workbench: '门户',
    library: '文件库',
    memo: '备忘录',
    approval: '审批中心',
    project: '项目协作',
    knowledge: '知识库',
    knowledgeDoc: '知识文档',
    email: '邮件管理',
    report: '数据报表',
    attendance: '考勤中心',
    salary: '智能薪酬',
    task: '任务',
    schedule: '日程',
    personnelMatrix: '人员矩阵',
    determine: '确定',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    down: '下载',
    import: '导入',
    export: '导出',
    picture: '图片',
    video: '视频',
    audio: '音频',
    file: '文档',
    nothing: '无',
    newbuilt: '新建',
    nodata: '暂无数据~',
    noAuthority: '无权限查看数据',
    noAuthorityOrDelete: '无权查看或数据已删除',
    noAuthorityOperate: '无权进行此操作',
    nomodulepermission: '无模块权限',
    nomenupermission: '无菜单权限',
    more: '更多',
    screen: '筛选',
    filter: '筛选',
    clear: '清空',
    goback: '返回',
    edit: '编辑',
    update: '修改',
    delete: '删除',
    remove: '移除',
    add: '新增',
    adjunction: '添加',
    copy: '复制',
    open: '打开',
    query: '查询',
    previews: '预览',
    yes: '是',
    no: '否',
    on: '开启',
    off: '关闭',
    rename: '重命名',
    comment: '沟通',
    relation: '关联',
    member: '成员',
    addMember: '添加成员',
    sharedMembers: '共享成员',
    look: '查看',
    set: '设置',
    close: '关闭',
    search: '搜索',
    select: '选择',
    selectAll: '全选',
    to: '至',
    stopUsing: '停用',
    disable: '禁用',
    enable: '启用',
    year: '年',
    month: '月',
    week: '周',
    day: '日',
    day2: '天',
    hour: '小时',
    minute: '分钟',
    ge: '个',
    tiao: '条',
    yuan: '元',
    tips: '提示',
    mustFill: '必填',
    required: '必填项',
    norecoverable: '删除后不可恢复',
    determineDelete: '你确定要删除吗?',
    print: '打印',
    upload: '上传',
    uploadFiles: '上传文件',
    size: '大小',
    status: '状态',
    administrator: '管理员',
    time: '时间',
    createTime: '创建时间',
    create_by: '创建人',
    modify_time: '修改时间',
    start_time: '开始时间',
    end_time: '结束时间',
    modify_by: '修改人',
    operation: '操作',
    approvalTypeAfterReject: '驳回后审批方式',
    spread: '展开',
    retract: '收起',
    man: '男',
    woman: '女',
    person: '人',
    content: '内容',
    visibleRange: '可见范围',
    networkFailPleaseTryAgain: '网络异常，请稍候重试',
    SelectDataMinOne: '最少选择一条数据',
    uncultivated: '该功能暂未开发',
    roledepemp: '成员、部门、角色',
    custom: '自定义',
    // 20210305
    sso: '单点登录',
    page404: '抱歉，你访问的页面不存在',
    local: '本地',
    // 20210715
    taskYdt: '我的待办',
    tip: {
      deleteTip: '删除后不可恢复。'
    },
    message: {
      addSuccess: '新增成功',
      editorSuccess: '编辑成功',
      copySuccess: '复制成功',
      moveSuccess: '移动成功',
      success: '保存成功',
      upload: '上传成功',
      delete: '删除成功',
      operate: '操作成功',
      send: '发送成功',
      perform: '执行成功',
      playFail: '执行失败',
      import: '导入成功',
      timeRange: '范围请选择开始时间和截止时间',
      refushTip: '数据已更新，请刷新页面'
    },
    placeholder: {
      all: '全部',
      selected: '选中',
      input: '请输入',
      select: '请选择',
      select_must: '请选择(必填)',
      pwd: '请输入密码',
      newpwd: '请输入新密码',
      confirmpwd: '确认密码',
      code: '请输入验证码',
      phone: '请输入手机号码',
      keywords: '请输入关键字',
      chooseDate: '选择日期',
      chooseTime: '选择时间',
      chooseYM: '选择年月',
      chooseDatetime: '选择日期时间',
      ctrlEnter: '评论内容（Ctrl+Enter发送）',
      matrixName: '请输入矩阵名称',
      jobPositionName: '请输入岗位名称'
    },
    error: {
      empty: '不能为空',
      noAuthority: '没有权限',
      phone: '手机号码格式错误',
      phone_empty: '手机号码不能为空',
      name_empty: '名称不能为空',
      pwd: '密码格式错误',
      pwd_empty: '密码不能为空',
      pwd_atypism: '两次密码输入不一致',
      pwd_accordwith: '密码必须符合要求',
      code: '验证码错误',
      code_empty: '验证码不能为空',
      PwdPopover: '密码最小长度至少',
      PwdPopover0: '个字符',
      PwdPopover1: '个字符且必须包含字母和数字字符',
      PwdPopover2: '个字符且必须包含字母、数字和特殊字符',
      PwdPopover3: '个字符且必须包含数字和大小写字母',
      PwdPopover4: '个字符且必须包含数字、大小写字母和特殊字符',
      fileSize: '单个文件大小不能超过100M',
      fileSize2: '文件大小不得超过200MB',
      fileSize20: '文件大小不得超过20MB',
      formatError: '格式错误',
      formatError2: '上传格式错误',
      scaleError: '小数位数错误',
      outOfInputRange: '超出输入范围',
      enterMin: '输入最小值',
      enterMax: '输入最大值',
      visibleRange_empty: '可见范围不能为空'
    },
    screenInfo: {
      // 筛选信息
      asc: '升序',
      desc: '降序',
      Filled: '已填写',
      notFilled: '未填写',
      today: '今天',
      yesterday: '昨天',
      thisWeek: '本周',
      lastWeek: '上周',
      pastSevenDays: '过去7天',
      past30Days: '过去30天',
      thisMonth: '本月',
      lastMonth: '上月',
      thisQuarter: '本季度',
      lastQuarter: '上季度',
      thisYear: '本年',
      lastYear: '上年',
      timeRange: '范围'
    },
    weeks: {
      Mon: '星期一',
      Tues: '星期二',
      Wed: '星期三',
      Thur: '星期四',
      Fri: '星期五',
      Sat: '星期六',
      Sun: '星期日'
    },
    weeksTwo: {
      Mon: '周一',
      Tues: '周二',
      Wed: '周三',
      Thur: '周四',
      Fri: '周五',
      Sat: '周六',
      Sun: '周日'
    },
    weeksThree: {
      Mon: '一',
      Tues: '二',
      Wed: '三',
      Thur: '四',
      Fri: '五',
      Sat: '六',
      Sun: '日'
    },
    userInfo: {
      name: '姓名',
      gender: '性别',
      department: '部门',
      company: '机构',
      superior: '上级',
      landline: '座机',
      phone: '手机',
      tel: '电话',
      email: '邮箱',
      birthday: '生日',
      emid: '工号',
      enable: '状态',
      postName: '职务',
      roleName: '角色',
      account: '账号',
      area: '地区',
      address: '地址',
      material: '资料',
      activated: '已激活',
      notActive: '未激活',
      hobbie: '兴趣爱好'
    },
    comments: {
      moreCommon: '条更多评论',
      backTop: '返回顶部',
      expression: '表情',
      send: '发送',
      message_empty: '不能发送空白评论'
    },
    members: {
      selectMember: '选择成员',
      selected: '已选',
      includingSubordinateDepartment: '包含下级部门',
      member: '成员',
      department: '部门',
      role: '角色',
      dynamicParameters: '动态参数',
      current_login_personnel: '当前成员',
      current_main_department: '当前部门'
    },
    preview: {
      image: '图片',
      rotate: '左旋转',
      rotate1: '右旋转',
      magnif: '放大',
      shrink: '缩小',
      dpwnload: '下载',
      fullScreen: '全屏查看',
      exitfull: '退出全屏'
    },
    insufficientAuth: '权限不足，请联系系统管理员',
    gobackBaseModule: '返回基础模块',
    action: {
      pause: '暂停',
      archive: '归档',
      release: '发布',
      undo: '撤销',
      transferleader: '转移负责人',
      share: '共享',
      retreattotheopenseapool: '退回公海池',
      convert: '转换',
      pickup: '领取',
      allocate: '分配',
      move: '移动',
      batchmodification: '批量修改',
      recovery: '恢复',
      managefolders: '管理文件夹',
      setupadministrator: '设置管理员',
      setpermissions: '设置权限',
      completelydelete: '彻底删除',
      recoverymemo: '恢复备忘',
      reset: '重置',
      enabledisable: '启用/禁用',
      accountbinding: '账户绑定',
      processapproval: '流程审批',
      modifyapprover: '修改审批人'
    },
    image: {
      fill: '填充',
      adapt: '适应',
      stretch: '拉伸',
      tiled: '平铺',
      centere: '居中'
    },
    data: '数据'
  }
}
